import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { Alert, AlertTitle } from '@mui/material';
import { AlertItem, dismissAlertItem } from 'src/redux/common/commonSlice';
import { useStyles } from './pru-alert.style';

type PruAlertProps = {
  alertState: AlertItem[];
};

export const PruAlert: FC<PruAlertProps> = ({ alertState }) => {
  const { classes } = useStyles();
  const dispatch = useDispatch();

  return (
    <div className={classes.alertContainer}>
      {alertState &&
        alertState.map((alertItem, index) => {
          setTimeout(() => dispatch(dismissAlertItem({ index })), 5000);
          const onClose = () => {
            dispatch(dismissAlertItem({ index }));
          };
          return (
            <Alert
              key={`alert-item-${index}`}
              severity={alertItem.severity}
              action={alertItem.action ? alertItem.action(onClose) : undefined}
              onClose={onClose}
            >
              {alertItem.title && <AlertTitle>{alertItem.title}</AlertTitle>}
              {alertItem.content}
            </Alert>
          );
        })}
    </div>
  );
};
